import styled from "@emotion/styled";

const PlayerError = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: 100%;
  width: 100%;
  min-height: 200px;
  background: linear-gradient(135deg, #0d1b2a 0%, #1b2838 100%);
`;

export default PlayerError;
